import angular from 'angular';
import addAlertMessageComponent from './addAlertMessage.component';

let addAlertMessageModule = angular.module('addAlertMessage', []).component('addAlertMessage', addAlertMessageComponent);

export default addAlertMessageModule;



// WEBPACK FOOTER //
// ./app/components/addAlertMessage/addAlertMessage.js